import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { lazy, Suspense } from 'react';
import { useDialog } from '../../../../../hooks/use-dialog';

const FileFeedDialog = lazy(() =>
  import('./MeasurementsUploadDialog').then((m) => ({ default: m.MeasurementsUploadDialog })),
);

export const FileFeedMenuItem: React.FC = () => {
  const { isDialogOpen, handleOpen, handleClose } = useDialog();

  return (
    <>
      <MenuItem onClick={handleOpen}>
        <ListItemIcon>
          <VyIcon
            icon="DocumentFileUploadCenterArrow"
            style={{
              transform: 'scale(0.7)',
            }}
          />
        </ListItemIcon>
        <ListItemText>Upload data</ListItemText>
      </MenuItem>

      {isDialogOpen && (
        <Suspense fallback={null}>
          <FileFeedDialog open={isDialogOpen} onClose={handleClose} />
        </Suspense>
      )}
    </>
  );
};
